module.exports = __webpack_public_path__ + "static/media/cherry-46.29ecfee5.png";